import { Language } from './base';

const pdash = () => import('../translations/pdash/it-IT.json');
const webActivities = () => import('../translations/web-activities/it-IT.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/it-IT.json');

export default new Language({
    code: 'it-IT',
    locale: 'it',
    localName: 'Italiano',
    englishName: 'Italian',
    territory: 'IT',
    timezones: ['Europe/Rome'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
